<template>
  <div>
    <div
      style="position: absolute; top: 25px; right: 25px"
      height="100"
      class="red"
    >
      {{ location.latitude }}, 100
    </div>
    <div v-if="ready" @mouseleave="info.show = false">
      <GmapMap
        ref="map"
        id="map"
        v-if="user"
        :center="{ lat: 25.655459, lng: -100.385829 }"
        :zoom="location.zoom"
        :options="{
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          styles,
        }"
        map-type-id="roadmap"
        class="map"
        @click="info.show = false"
        @zoom_changed="zoom_calc"
      >
        <div v-if="records">
          <div v-if="currMeters.length === 0 && i === 0">
            <!-- @onmouseout="info.show = false" -->
            <div :key="index" v-for="(meter, index) in meters">
              <GmapMarker
                id="meter.name"
                v-if="meter.location"
                :position="{
                  lat: meter.location.latitude,
                  lng: meter.location.longitude,
                }"
                :visible="true"
                :icon="getIcon(meter.name, meter.issue)"
                :ref="meter.name"
                :clickable="true"
                @click="selectMarker($event, meter.name)"
              />
            </div>
          </div>
          <div v-else>
            <!-- @onmouseout="info.show = false" -->
            <div :key="meter.name" v-for="meter in currMeters">
              <GmapMarker
                id="meter.name"
                v-if="meter.location"
                :position="{
                  lat: meter.location.latitude,
                  lng: meter.location.longitude,
                }"
                :visible="true"
                :icon="getIcon(meter.name, meter.issue)"
                :ref="meter.name"
                :clickable="true"
                @click="selectMarker($event, meter.name)"
              />
            </div>
          </div>
        </div>
      </GmapMap>
      <div class="filterOn">
        <v-btn-toggle>
          <v-btn
            x-small
            color="white"
            :class="colors[0]"
            @click="retrieveMeters(categories[0])"
            >{{ textBtns[0] }}</v-btn
          >
          <v-btn
            x-small
            color="white"
            :class="colors[1]"
            @click="retrieveMeters(categories[1])"
            >{{ textBtns[1] }}</v-btn
          >
          <v-btn
            x-small
            color="white"
            :class="colors[2]"
            @click="retrieveMeters(categories[2])"
            >{{ textBtns[2] }}</v-btn
          >
          <v-btn
            x-small
            color="white"
            :class="colors[3]"
            @click="retrieveMeters(categories[3])"
            >{{ textBtns[3] }}</v-btn
          >
          <v-btn
            x-small
            v-if="$route.params.btn >= 6"
            color="white"
            :class="colors[4]"
            @click="retrieveMeters(categories[4])"
            >{{ textBtns[4] }}</v-btn
          >
          <v-btn
            x-small
            v-if="$route.params.btn >= 6"
            color="white"
            :class="colors[5]"
            @click="retrieveMeters(categories[5])"
            >{{ textBtns[5] }}</v-btn
          >
          <v-btn
            x-small
            v-if="$route.params.btn >= 6"
            color="white"
            :class="colors[6]"
            @click="retrieveMeters(categories[6])"
            >{{ textBtns[6] }}</v-btn
          >
          <v-btn
            x-small
            v-if="$route.params.btn >= 10"
            color="white"
            :class="colors[7]"
            @click="retrieveMeters(categories[7])"
            >{{ textBtns[7] }}</v-btn
          >
          <v-btn
            x-small
            v-if="$route.params.btn >= 10"
            color="white"
            :class="colors[8]"
            @click="retrieveMeters(categories[8])"
            >{{ textBtns[8] }}</v-btn
          >
          <v-btn
            x-small
            v-if="$route.params.btn >= 10"
            color="white"
            :class="colors[9]"
            @click="retrieveMeters(categories[9])"
            >{{ textBtns[9] }}</v-btn
          >
          <v-btn
            x-small
            v-if="$route.params.btn >= 10"
            color="white"
            :class="colors[10]"
            @click="retrieveMeters(categories[10])"
            >{{ textBtns[10] }}</v-btn
          >
        </v-btn-toggle>
      </div>
      <!-- <div style="position: relative; top: 50px" @onmouseout="info.show = false"> -->
      <v-row v-if="info.show" style="position: relative; top: 50px">
        <v-col class="d-flex justify-end align-right">
          <v-card v-model="info.show" width="500px">
            <v-card-title class="text-uppercase mb-n1"
              >{{ info.meter.circuit }}<v-spacer></v-spacer
              ><v-btn icon @click="closeCard()"
                ><v-icon>mdi-close</v-icon></v-btn
              ></v-card-title
            >
            <v-card-subtitle class="text-left text-uppercase">{{
              info.meter.name
            }}</v-card-subtitle>
            <v-divider></v-divider>
            <v-list>
              <v-list-item>
                <v-list-item-content v-if="info.meter" class="mt-n3">
                  <v-list-item-title class="ml-n4 text-left">
                    <v-list-item-subtitle v-if="type === 'general'">
                      <v-card-text class="mb-n4" v-if="info.comm != ''"
                        >Last comment: {{ info.comm }} on
                        {{ info.commDate }}</v-card-text
                      >
                      <v-card-text class="mb-n4" v-else
                        >There are no comments posted about his
                        device</v-card-text
                      >
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="type === 'consumption'">
                      <v-card-text class="mb-n4"
                        >Power at moment:
                        {{
                          info.record.lines
                            .reduce((suma, l) => suma + l.watts, 0)
                            .toFixed(2)
                        }}
                        W</v-card-text
                      >
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="type === 'signal'">
                      <v-card-text class="mb-n4"
                        >Signal at moment:
                        {{ info.record.status.rssi }} RSSI</v-card-text
                      >
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="type === 'temperature'">
                      <v-card-text class="mb-n4"
                        >Temperature at moment:
                        {{ info.temp.temp }}°F</v-card-text
                      >
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="type === 'humidity'">
                      <v-card-text class="mb-n4"
                        >Humidity at moment:
                        {{ info.humid.humidity.toFixed(0) }}%</v-card-text
                      >
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="type === 'light'">
                      <v-card-text class="mb-n4"
                        >Light at moment:
                        {{ info.light.light.toFixed(0) }}%</v-card-text
                      >
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="mt-n5">
                      <v-card-text v-if="info.record"
                        >Last read: {{ info.date }}</v-card-text
                      >
                    </v-list-item-subtitle>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="mt-n5">
                <v-list-item-subtitle v-if="info.record" class="text-center">
                  <v-row align="center">
                    <v-col class="d-flex justify-center align-center" cols="4"
                      ><v-chip
                        class="long"
                        color="primary"
                        text-color="white"
                        label
                        >{{
                          info.record.lines
                            .reduce((suma, l) => suma + l.watts, 0)
                            .toFixed(2)
                        }}
                        W</v-chip
                      ></v-col
                    >
                    <v-col class="d-flex justify-center align-center" cols="4"
                      ><v-chip
                        class="long"
                        color="primary"
                        text-color="white"
                        label
                        >{{
                          info.record.lines
                            .reduce((suma, l) => suma + l.amps, 0)
                            .toFixed(2)
                        }}
                        A</v-chip
                      ></v-col
                    >
                    <v-col class="d-flex justify-center align-center" cols="4"
                      ><v-chip
                        class="long"
                        color="primary"
                        text-color="white"
                        label
                        >{{
                          Object.entries(
                            info.record.lines.reduce(
                              (acc, l) =>
                                l.volts > 10
                                  ? (acc = {
                                      suma: acc.suma + l.volts,
                                      lines: acc.lines + 1,
                                    })
                                  : acc,
                              { suma: 0, lines: 0 }
                            )
                          )
                            .reduce((total, el) => {
                              if (el[0] == "suma") return total + el[1];
                              else if (total == 0) return 0;
                              else return total / el[1];
                            }, 0)
                            .toFixed(2)
                        }}
                        V</v-chip
                      ></v-col
                    >
                  </v-row>
                </v-list-item-subtitle>
              </v-list-item>
              <v-divider class="mt-3 mb-n3"></v-divider>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-left ml-n3">
                    <v-card-title
                      class="font-weight-bold grey--text text--darken-1 mb-n3"
                      style="font-size: 14px"
                      ><v-icon class="mr-2">mdi-led-on</v-icon>Control<v-spacer
                      ></v-spacer
                      ><v-btn
                        v-if="user.level != 'USER'"
                        small
                        :color="
                          info.adv.control ? 'green accent-1' : 'grey lighten-3'
                        "
                        elevation="0"
                        @click="
                          switchControl(
                            'control',
                            info.adv.control,
                            info.meter.circuit,
                            info.meter.name
                          )
                        "
                        >{{ info.adv.control ? "ON" : "OFF" }}</v-btn
                      ></v-card-title
                    >
                    <v-card-title
                      class="font-weight-bold grey--text text--darken-1 mb-n3"
                      style="font-size: 14px"
                      ><v-icon class="mr-2">mdi-solar-panel-large</v-icon
                      >Photocell<v-spacer></v-spacer
                      ><v-btn
                        v-if="user.level != 'USER'"
                        small
                        :color="
                          info.adv.fotocelda
                            ? 'green accent-1'
                            : 'grey lighten-3'
                        "
                        elevation="0"
                        @click="
                          switchControl(
                            'fotocelda',
                            info.adv.fotocelda,
                            info.meter.circuit,
                            info.meter.name
                          )
                        "
                        >{{ info.adv.fotocelda ? "ON" : "OFF" }}</v-btn
                      ></v-card-title
                    >
                    <v-card-title
                      class="font-weight-bold grey--text text--darken-1 mb-n3"
                      style="font-size: 14px"
                      ><v-icon class="mr-2">mdi-clock</v-icon>Schedule
                      Configuration<v-spacer></v-spacer
                      >{{ info.adv.suntime ? "Solar" : "Manual" }}</v-card-title
                    >
                    <v-card-title
                      class="font-weight-bold grey--text text--darken-1 mb-n3"
                      style="font-size: 14px"
                      ><v-icon class="mr-2">mdi-lightbulb-on-outline</v-icon>ON
                      Schedule<v-spacer></v-spacer
                      >{{ info.sch.ON }}</v-card-title
                    >
                    <v-card-title
                      class="font-weight-bold grey--text text--darken-1 mb-n3"
                      style="font-size: 14px"
                      ><v-icon class="mr-2">mdi-lightbulb</v-icon>OFF
                      Schedule<v-spacer></v-spacer
                      >{{ info.sch.OFF }}</v-card-title
                    >
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-n1"></v-divider>
              <v-list-item v-if="user.level != 'USER'">
                <v-row>
                  <v-col>
                    <v-btn
                      elevation="0"
                      class="mt-2"
                      block
                      color="secondary"
                      :to="{ name: 'Circuit', params: { id: info.meter.name } }"
                      >View on dashboard</v-btn
                    >
                    <v-btn
                      elevation="0"
                      class="mt-2 white--text"
                      block
                      color="danger"
                      @click="reportIssue(info.meter.name, info.meter.issue)"
                      >Report Issue</v-btn
                    >
                    <v-btn
                      elevation="0"
                      class="mt-2"
                      block
                      color="accent"
                      @click="solveIssue(info.meter.name, info.meter.issue)"
                      >Solve Issue</v-btn
                    >
                    <v-btn
                      elevation="0"
                      class="mt-2 white--text"
                      block
                      color="grey"
                      @click="shareLocation(info.meter.name)"
                      >Share Location</v-btn
                    >
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
      <!-- </div> -->
      <a href="https://mapicons.mapsmarker.com/" class="license">
        <img src="@/assets/map/license.gif" alt="license" />
      </a>
      <v-snackbar v-model="snackbar">
        Location copied to clipboard
        <template v-slot:action="{ attrs }">
          <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
    <div v-else style="height: 100%; position: relative">
      <v-row>
        <v-col
          align="center"
          justify="center"
          style="position: absolute; top: 280px"
        >
          <v-progress-circular
            class="pcirc"
            width="5"
            size="50"
            indeterminate
            color="accent"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-model="openConfirm"
      persistent
      width="400"
      class="align-center"
      style="z-index: 1000"
    >
      <template>
        <v-card height="160">
          <v-toolbar :elevation="0" color="primary" dark
            ><v-toolbar-title>Confirm changes</v-toolbar-title></v-toolbar
          >
          <v-form ref="form" class="text-center mt-3"
            >Do you want to {{ cmd.msg }} {{ cmd.mod }} for
            {{ cmd.meter }}?</v-form
          >
          <div align="right" class="align-content-end mx-4 mt-3">
            <v-btn
              color="accent"
              :loading="loading"
              small
              class="white--text mx-2"
              @click="sendCommand(cmd, info.adv)"
              >Confirm</v-btn
            >
            <v-btn color="danger" small text @click="openConfirm = false"
              >Cancel</v-btn
            >
          </div>
        </v-card>
      </template>
    </v-dialog>
    <v-snackbar
      v-model="msgbox.show"
      :timeout="3000"
      :color="msgbox.err ? 'danger' : 'black'"
    >
      {{ msgbox.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          :color="msgbox.err ? 'black' : 'danger'"
          text
          v-bind="attrs"
          @click="msgbox.show = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { default as mapStyle } from "../plugins/mapStyle.json";
import * as VueGoogleMaps from "vue2-google-maps";
import moment from "moment";
import { Meter } from "../api";
export default {
  name: "MapView",
  computed: {
    google: VueGoogleMaps.gmapApi,
    ...mapState({
      user: (state) => state.user.profile,
      userInfo: (state) => state.meters.userInfo,
      meters: (state) =>
        state.meters.meters.map((m) => ({
          name: m.name,
          circuit: m.circuit,
          location: m.location,
          issue: m.issue,
          capacity: m.capacity,
        })),
      records: (state) => state.meters.lastReadings,
      comments: (state) => state.meters.comments,
      allComments: (state) => state.meters.allComments,
      arrayON: (state) => state.meters.arrayON,
      arrayUP: (state) => state.meters.arrayUP,
      arrayDOWN: (state) => state.meters.arrayDOWN,
      arrayOFF: (state) => state.meters.arrayOFF,
      arrayOUT: (state) => state.meters.arrayOUT,
      watts: (state) => state.meters.watts,
      wattsData: (state) => state.meters.wattsData,
      rangeArrayWatts: (state) => state.meters.rangeArrayWatts,
      signals: (state) => state.meters.signals,
      signalData: (state) => state.meters.signalData,
      rangeArraySignals: (state) => state.meters.rangeArraySignals,
      arrayStatus: (state) => state.meters.arrayStatus,
      arrayTemps: (state) => state.meters.arrayTemps,
      rangeTemps: (state) => state.meters.rangeTemps,
      rangeArrayTemps: (state) => state.meters.rangeArrayTemps,
      arrayLights: (state) => state.meters.arrayLights,
      rangeLights: (state) => state.meters.rangeLights,
      rangeArrayLights: (state) => state.meters.rangeArrayLights,
      arrayHumids: (state) => state.meters.arrayHumids,
      rangeHumids: (state) => state.meters.rangeHumids,
      rangeArrayHumids: (state) => state.meters.rangeArrayHumids,
      arrayMeterLinks: (state) => state.meters.arrayMeterLinks,
      sunrise_suntime_hours: (state) => state.user.sunrise_suntime_hours,
      sunrise_suntime_minutes: (state) => state.user.sunrise_suntime_minutes,
      sunset_suntime_hours: (state) => state.user.sunset_suntime_hours,
      sunset_suntime_minutes: (state) => state.user.sunset_suntime_minutes,
      sky_ofs: (state) => state.user.sky_ofs,
    }),
    ...mapGetters({
      getMeter: "meters/getMeter",
    }),
    mapCustom() {
      return mapStyle;
    },
    styles() {
      return this.mapCustom;
    },
  },
  data() {
    return {
      info: {
        show: false,
        issue: false,
        date: "",
        comm: "",
        commDate: "",
        humid: null,
        light: null,
        temp: null,
        num: 1,
        adv: null,
        sch: {
          ON: null,
          OFF: null,
        },
      },
      cmd: {
        msg: "",
        mod: "",
        meter: "",
        id: "",
        st: false,
      },
      msgbox: {
        show: false,
        text: "",
        err: false,
      },
      loading: false,
      openConfirm: false,
      size: 0,
      issue: false,
      solved: false,
      mapLoaded: false,
      metersVisible: false,
      gMapLink: "",
      snackbar: false,
      currMeters: [],
      i: 0,
      location: {
        latitude: null,
        longitude: null,
        zoom: null,
      },
      categories: [],
      colors: [],
      ready: false,
      textBtns: [],
      folder: "",
      icons: [],
      type: "",
      prop: "",
      subprop: "",
      mainArray: [],
      rangesArray: [],
      devicesArray: [],
    };
  },
  methods: {
    ...mapActions({
      checkIssue: "meters/checkIssue",
      uncheckIssue: "meters/uncheckIssue",
      filteredMeters: "meters/filteredMeters",
      getComments: "meters/getComments",
      controlMeter: "meters/controlMeter",
    }),
    async selectMarker(e, meter) {
      this.info.show = false;
      this.$refs.map.panTo({ lat: e.latLng.lat(), lng: e.latLng.lng() });
      this.info.meter = this.meters.find((m) => m.name == meter);
      let mt = this.getMeter(meter);
      let mt2 = await Meter.get({ id: mt.name, key: mt.key });
      this.info.adv = mt2.data;
      if (this.info.adv.suntime) {
        this.info.sch.OFF = `${this.sunrise_suntime_hours}:${this.sunrise_suntime_minutes}`;
        this.info.sch.ON = `${this.sunset_suntime_hours}:${this.sunset_suntime_minutes}`;
      } else {
        if (this.info.adv.schedule.OFF === null) this.info.sch.OFF = "N/A";
        else {
          let off_sch = this.info.adv.schedule.OFF.split(":").map((t) =>
            parseInt(t)
          );
          off_sch[0] += this.sky_ofs;
          if (off_sch[0] < 0) off_sch[0] += 24;
          this.info.sch.OFF = `${off_sch[0]}:${
            off_sch[1] < 10 ? `0${off_sch[1]}` : off_sch[1]
          }`;
        }
        if (this.info.adv.schedule.ON === null) this.info.sch.ON = "N/A";
        else {
          let on_sch = this.info.adv.schedule.ON.split(":").map((t) =>
            parseInt(t)
          );
          on_sch[0] += this.sky_ofs;
          if (on_sch[0] < 0) on_sch[0] += 24;
          this.info.sch.ON = `${on_sch[0]}:${
            on_sch[1] < 10 ? `0${on_sch[1]}` : on_sch[1]
          }`;
        }
      }

      this.info.record = this.records.find((m) =>
        m ? m.meter == meter : false
      );
      this.info.show = true;
      let day = new Date(this.info.record.timestamp).getDate();
      let m = new Date(this.info.record.timestamp).getMonth();
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      let hour = moment(
        new Date(this.info.record.timestamp).toLocaleTimeString(),
        "HH:mm:ss"
      ).format("HH:mm");
      this.info.date = months[m] + " " + String(day) + " @ " + hour;
      let comm = this.allComments.find((m) => m.name === meter);
      if (comm.comments.length > 0) {
        this.info.comm = comm.comments[0].content;
        let m_comm = Number(comm.comments[0].date.substr(0, 2)) - 1;
        let d_comm = Number(comm.comments[0].date.substr(3, 2));
        this.info.commDate = months[m_comm] + " " + d_comm;
      } else this.info.comm = "";
      this.info.light = this.arrayLights.find(
        (m) => m.meter == this.info.meter.circuit
      );
      this.info.humid = this.arrayHumids.find(
        (m) => m.meter == this.info.meter.circuit
      );
      this.info.temp = this.arrayTemps.find(
        (m) => m.meter == this.info.meter.circuit
      );
    },
    switchControl(mode, status, meter, id) {
      this.openConfirm = true;
      this.cmd.msg = status ? "deactivate" : "activate";
      this.cmd.mod = mode;
      this.cmd.meter = meter;
      this.cmd.id = id;
      this.cmd.st = !status;
    },
    async sendCommand(cmd, info) {
      try {
        this.loading = true;
        await this.controlMeter({
          meter: cmd.id,
          control: cmd.mod === "control" ? cmd.st : info.control,
          fotocelda: cmd.mod === "fotocelda" ? cmd.st : info.fotocelda,
        });
        await this.sleep(2000).then(() => {
          this.loading = false;
        });
        this.openConfirm = false;
        this.msgbox.err = false;
        let m = cmd.mod === "control" ? "Control" : "Photocell";
        this.msgbox.text = `${m} successfully ${
          cmd.st ? "activated" : "deactivated"
        }`;
        this.msgbox.show = true;
      } catch (error) {
        this.loading = false;
        this.openConfirm = false;
        this.msgbox.err = true;
        let m = cmd.mod === "control" ? "Control" : "Photocell";
        this.msgbox.text = `${m} could not be ${
          cmd.st ? "activated" : "deactivated"
        }`;
        this.msgbox.show = true;
      }
    },
    zoom_calc() {
      let zoomArr = [
        4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
      ];
      let sizeArr = [
        4, 4, 4, 6, 6, 6, 6, 6, 10, 20, 20, 20, 30, 30, 30, 40, 40, 40, 40,
      ];
      if (!this.$refs.map) {
        let sizeIndex = 13;
        this.size = sizeArr[sizeIndex];
        return;
      }
      this.$refs.map.$mapPromise.then((map) => {
        let zoom = map.getZoom();
        let sizeIndex = zoomArr.findIndex((s) => s == zoom);
        this.size = sizeArr[sizeIndex];
      });
    },
    getIcon(meter, issue) {
      let device = this.mainArray.find((d) =>
        d ? d[this.prop] === meter : false
      );
      let n;
      if (issue === true) {
        return {
          url: require("@/assets/map/icon-purple.png"),
          scaledSize: { width: this.size, height: this.size, f: "px", b: "px" },
        };
      }
      if (device != undefined) {
        if (this.type === "general") {
          let a_UP = this.arrayUP;
          let a_DOWN = this.arrayDOWN;
          let a_ON = this.arrayON;
          let a_OFF = this.arrayOFF;
          let a_OUT = this.arrayOUT;

          n = a_UP.find((d) => d.name === device.name);
          if (n != undefined)
            return {
              url: require("@/assets/map/icon-orange.png"),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          n = a_DOWN.find((d) => d.name === device.name);
          if (n != undefined)
            return {
              url: require("@/assets/map/icon-yellow.png"),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          n = a_ON.find((d) => d.name === device.name);
          if (n != undefined)
            return {
              url: require("@/assets/map/icon-green.png"),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          n = a_OFF.find((d) => d.name === device.name);
          if (n != undefined)
            return {
              url: require("@/assets/map/icon-dark.png"),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          n = a_OUT.find((d) => d.name === device.name);
          if (n != undefined)
            return {
              url: require("@/assets/map/icon-red.png"),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
        } else {
          let reg;
          if (this.type === "consumption") {
            reg = device[this.subprop]
              .reduce((suma, l) => suma + l.watts, 0)
              .toFixed(2);
          } else if (this.type === "signal") {
            reg = Math.abs(device[this.subprop].rssi);
          } else {
            reg = device[this.subprop];
          }
          if (reg >= this.rangesArray[0] && reg <= this.rangesArray[1]) {
            return {
              url: require(`@/assets/${this.folder}/${this.icons[0]}.png`),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          } else if (reg > this.rangesArray[1] && reg <= this.rangesArray[2]) {
            return {
              url: require(`@/assets/${this.folder}/${this.icons[1]}.png`),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          } else if (reg > this.rangesArray[2] && reg <= this.rangesArray[3]) {
            return {
              url: require(`@/assets/${this.folder}/${this.icons[2]}.png`),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          } else if (reg > this.rangesArray[3] && reg <= this.rangesArray[4]) {
            return {
              url: require(`@/assets/${this.folder}/${this.icons[3]}.png`),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          } else if (reg > this.rangesArray[4] && reg <= this.rangesArray[5]) {
            return {
              url: require(`@/assets/${this.folder}/${this.icons[4]}.png`),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          } else if (reg > this.rangesArray[5] && reg <= this.rangesArray[6]) {
            return {
              url: require(`@/assets/${this.folder}/${this.icons[5]}.png`),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          } else if (reg > this.rangesArray[6] && reg <= this.rangesArray[7]) {
            return {
              url: require(`@/assets/${this.folder}/${this.icons[6]}.png`),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          } else if (reg > this.rangesArray[7] && reg <= this.rangesArray[8]) {
            return {
              url: require(`@/assets/${this.folder}/${this.icons[7]}.png`),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          } else if (reg > this.rangesArray[8] && reg <= this.rangesArray[9]) {
            return {
              url: require(`@/assets/${this.folder}/${this.icons[8]}.png`),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          } else {
            return {
              url: require(`@/assets/${this.folder}/${this.icons[9]}.png`),
              scaledSize: {
                width: this.size,
                height: this.size,
                f: "px",
                b: "px",
              },
            };
          }
        }
      }
      return {
        url: require("@/assets/map/icon-dark.png"),
        scaledSize: { width: this.size, height: this.size, f: "px", b: "px" },
      };
    },
    getIconDanger(meter) {
      let issue = this.issue;
      if (issue) {
        return {
          url: require("@/assets/map/icon-purple.png"),
          scaledSize: { width: this.size, height: this.size, f: "px", b: "px" },
        };
      }
    },
    async reportIssue(meter, prob) {
      this.issue = true;
      this.info.meter.issue = this.issue;
      let meter_id = meter;
      let issue = this.issue;
      await this.checkIssue({ meter_id, issue });
      this.info.show = false;
    },
    async solveIssue(meter, prob) {
      this.issue = false;
      this.info.meter.issue = this.issue;
      let meter_id = meter;
      let issue = this.issue;
      await this.checkIssue({ meter_id, issue });
      this.info.show = false;
    },
    setMap() {
      this.map = this.$refs.map.$mapObject;
      this.$refs.map.$mapCreated.then(() => {
        this.mapLoaded = true;
      });
    },
    async shareLocation(meter) {
      let m = this.meters.find((n) => (n ? n.name == meter : false));
      let l = this.arrayMeterLinks.find((i) => (i ? i.id == m.name : false));
      this.gMapLink = l.url;
      let copyText = this.gMapLink;
      navigator.clipboard.writeText(copyText);
      this.snackbar = true;
    },
    async retrieveMeters(status) {
      switch (status) {
        case "01":
          this.i = 1;
          this.currMeters = this.devicesArray[0];
          break;
        case "12":
          this.i = 2;
          this.currMeters = this.devicesArray[1];
          break;
        case "23":
          this.i = 3;
          this.currMeters = this.devicesArray[2];
          break;
        case "34":
          this.i = 4;
          this.currMeters = this.devicesArray[3];
          break;
        case "45":
          this.i = 5;
          this.currMeters = this.devicesArray[4];
          break;
        case "56":
          this.i = 6;
          this.currMeters = this.devicesArray[5];
          break;
        case "67":
          this.i = 7;
          this.currMeters = this.devicesArray[6];
          break;
        case "78":
          this.i = 8;
          this.currMeters = this.devicesArray[7];
          break;
        case "89":
          this.i = 9;
          this.currMeters = this.devicesArray[8];
          break;
        case "910":
          this.i = 10;
          this.currMeters = this.devicesArray[9];
          break;
        default:
          this.i = 0;
          this.currMeters = [];
          break;
      }
    },
    async setCategories(type) {
      this.ready = false;
      this.type = type;
      this.i = 0;
      this.currMeters = [];
      switch (type) {
        case "general":
          this.categories = ["ALL", "01", "12", "23"];
          this.colors = [
            "grey--text",
            "green--text",
            "black--text",
            "red--text",
          ];
          this.textBtns = [
            "All Devices",
            "ON Devices",
            "OFF Devices",
            "Offline Devices",
          ];
          this.folder = "map";
          this.icons = [
            "icon-orange",
            "icon-yellow",
            "icon-green",
            "icon-dark",
            "icon-red",
          ];
          this.prop = "name";
          this.mainArray = this.meters;
          this.rangesArray = [];
          this.subprop = "";
          this.devicesArray = this.arrayStatus;
          break;
        case "consumption":
          let w = this.watts;
          this.categories = ["ALL", "01", "12", "23", "34", "45", "56"];
          this.colors = [
            "grey--text",
            "red--text text--lighten-4",
            "red--text text--lighten-3",
            "red--text text--lighten-1",
            "red--text text--darken-1",
            "red--text text--darken-2",
            "red--text text--darken-3",
          ];
          this.textBtns = [
            "All Devices",
            `${w[0].toFixed(0)} W to ${w[1].toFixed(0)} W`,
            `${w[1].toFixed(0)} W to ${w[2].toFixed(0)} W`,
            `${w[2].toFixed(0)} W to ${w[3].toFixed(0)} W`,
            `${w[3].toFixed(0)} W to ${w[4].toFixed(0)} W`,
            `${w[4].toFixed(0)} W to ${w[5].toFixed(0)} W`,
            `${w[5].toFixed(0)} W to ${w[6].toFixed(0)} W`,
          ];
          this.folder = "mapCons";
          this.icons = ["01", "12", "23", "34", "45", "56"];
          this.prop = "meter";
          this.mainArray = this.records;
          this.rangesArray = this.watts;
          this.subprop = "lines";
          this.devicesArray = this.rangeArrayWatts;
          break;
        case "signal":
          this.categories = [
            "ALL",
            "01",
            "12",
            "23",
            "34",
            "45",
            "56",
            "67",
            "78",
            "89",
            "910",
          ];
          this.colors = [
            "grey--text",
            "green--text",
            "light-green--text text--accent-3",
            "lime--text text--accent-3",
            "lime--text text--accent-2",
            "yellow--text",
            "yellow--text text--darken-1",
            "orange--text text--lighten-2",
            "deep-orange--text",
            "red--text text--darken-2",
            "red--text text--darken-3",
          ];
          this.textBtns = [
            "All Devices",
            "0 RSSI to -60 RSSI",
            "-61 RSSI to -65 RSSI",
            "-66 RSSI to -70 RSSI",
            "-71 RSSI to -75 RSSI",
            "-76 RSSI to -80 RSSI",
            "-81 RSSI to -85 RSSI",
            "-86 RSSI to -90 RSSI",
            "-91 RSSI to -95 RSSI",
            "-96 RSSI to -100 RSSI",
            "< -100 RSSI",
          ];
          this.folder = "mapSignal";
          this.icons = [
            "0-60",
            "61-65",
            "66-70",
            "71-75",
            "76-80",
            "81-85",
            "86-90",
            "91-95",
            "96-100",
            "100m",
          ];
          this.prop = "meter";
          this.mainArray = this.records;
          this.rangesArray = this.signals;
          this.subprop = "status";
          this.devicesArray = this.rangeArraySignals;
          break;
        case "temperature":
          let t = this.rangeTemps;
          this.categories = ["ALL", "01", "12", "23", "34", "45", "56"];
          this.colors = [
            "grey--text",
            "green--text text--darken-4",
            "light-green--text text--accent-3",
            "lime--text text--accent-2",
            "yellow--text text--darken-1",
            "orange--text text--lighten-2",
            "red--text text--darken-2",
          ];
          this.textBtns = [
            "All Devices",
            `${t[0].toFixed(0)}°F to ${t[1].toFixed(0)}°F`,
            `${t[1].toFixed(0)}°F to ${t[2].toFixed(0)}°F`,
            `${t[2].toFixed(0)}°F to ${t[3].toFixed(0)}°F`,
            `${t[3].toFixed(0)}°F to ${t[4].toFixed(0)}°F`,
            `${t[4].toFixed(0)}°F to ${t[5].toFixed(0)}°F`,
            `${t[5].toFixed(0)}°F to ${t[6].toFixed(0)}°F`,
          ];
          this.folder = "mapTemps";
          this.icons = ["0-5", "11-15", "16-20", "26-30", "31-35", "41-45"];
          this.prop = "meter";
          this.mainArray = this.arrayTemps;
          this.rangesArray = this.rangeTemps;
          this.subprop = "temp";
          this.devicesArray = this.rangeArrayTemps;
          break;
        case "humidity":
          let h = this.rangeHumids;
          this.categories = ["ALL", "01", "12", "23", "34", "45", "56"];
          this.colors = [
            "grey--text",
            "blue-grey--text text--lighten-3",
            "blue-grey--text text--lighten-2",
            "blue-grey--text text--lighten-1",
            "blue-grey--text text--darken-1",
            "blue-grey--text text--darken-2",
            "blue-grey--text text--darken-3",
          ];
          this.textBtns = [
            "All Devices",
            `${h[0].toFixed(0)}% to ${h[1].toFixed(0)}%`,
            `${h[1].toFixed(0)}% to ${h[2].toFixed(0)}%`,
            `${h[2].toFixed(0)}% to ${h[3].toFixed(0)}%`,
            `${h[3].toFixed(0)}% to ${h[4].toFixed(0)}%`,
            `${h[4].toFixed(0)}% to ${h[5].toFixed(0)}%`,
            `${h[5].toFixed(0)}% to ${h[6].toFixed(0)}%`,
          ];
          this.folder = "mapHumid";
          this.icons = ["01", "12", "23", "34", "45", "56"];
          this.prop = "meter";
          this.mainArray = this.arrayHumids;
          this.rangesArray = this.rangeHumids;
          this.subprop = "humidity";
          this.devicesArray = this.rangeArrayHumids;
          break;
        case "light":
          let l = this.rangeLights;
          this.categories = ["ALL", "01", "12", "23", "34", "45", "56"];
          this.colors = [
            "grey--text",
            "purple--text text--lighten-4",
            "purple--text text--lighten-3",
            "purple--text text--lighten-2",
            "purple--text text--lighten-1",
            "purple--text text--darken-1",
            "purple--text text--darken-2",
          ];
          this.textBtns = [
            "All Devices",
            `${l[0].toFixed(0)}% to ${l[1].toFixed(0)}%`,
            `${l[1].toFixed(0)}% to ${l[2].toFixed(0)}%`,
            `${l[2].toFixed(0)}% to ${l[3].toFixed(0)}%`,
            `${l[3].toFixed(0)}% to ${l[4].toFixed(0)}%`,
            `${l[4].toFixed(0)}% to ${l[5].toFixed(0)}%`,
            `${l[5].toFixed(0)}% to ${l[6].toFixed(0)}%`,
          ];
          this.folder = "mapLight";
          this.icons = ["01", "12", "23", "34", "45", "56"];
          this.prop = "meter";
          this.mainArray = this.arrayLights;
          this.rangesArray = this.rangeLights;
          this.subprop = "light";
          this.devicesArray = this.rangeArrayLights;
          break;
        default:
          break;
      }

      await this.sleep(2000).then(() => {
        this.ready = true;
      });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    closeCard() {
      delete this.info.meter;
      this.info.show = false;
    },
  },
  async created() {
    // console.log(this.userInfo.get());
    let ui = await this.userInfo.get();
    // console.log(this.user);
    // console.log(ui.data());
    // let user = JSON.parse(localStorage.getItem('user'))
    if (this.$route.params.location != undefined) {
      this.location.latitude = this.$route.params.location.ef;
      this.location.longitude = this.$route.params.location.nf;
      this.location.zoom = this.$route.params.zoom;
    } else {
      this.location.latitude = ui.data().location.ef;
      this.location.longitude = ui.data().location.nf;
      this.location.zoom = ui.data().map_zoom;
    }
  },
  mounted() {
    this.zoom_calc();
    let type = this.$route.params.id;
    this.setCategories(type);
  },
  watch: {
    "$route.params.id"() {
      this.setCategories(this.$route.params.id);
    },
    records() {
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.map {
  display: contents;
}
.license {
  position: absolute;
  z-index: 100;
  bottom: 10px;
  right: 8px;
}
.filterOn {
  position: absolute;
  z-index: 100;
  top: 10px;
  left: 8px;
}
.card {
  position: absolute;
  z-index: 100;
  top: 100px;
  left: 8px;
  height: 100px;
  width: 400px;
}
.v-btn-toggle {
  flex-direction: column;
}
.no-background-hover::before {
  background-color: transparent !important;
}
.long {
  width: 130px;
  display: block;
}
</style>
